<template>
  <div class="tabs_content">
    <section>
      <div class="table_overflow">
        <table class="vypis">
        <thead>
        <tr v-if="entities.length > 0">
          <th class="no_padding drag_drop"></th>
          <th class="no_padding checkbox"></th>
          <th><span class="name" v-translate>Cena</span></th>
          <th><span class="name" v-translate>Symbol</span></th>
          <th><span class="name" v-translate>Název měny</span></th>
        </tr>
        </thead>
        <tbody>
        <PricesRow v-for="entity in entities"
                    :entity="entity"
                    :key="entity.id"
                    ref="packages_row"
                    :selectedEntities="selectedEntities"
                    @input="select"/>
        <tr v-if="entities.length === 0">
          <td colspan="4" v-translate>Nebyly nalezeny žádné ceny.</td>
        </tr>
        </tbody>
      </table>
      </div>
      <local-list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
      ></local-list-action-line>
    </section>
  </div>
</template>

<script>
import localTable from "@/components/mixins/local-table"
import PricesRow from "./PricesRow.vue";

export default {
  name: "Prices",
  components: {PricesRow},
  mixins: [localTable],
  props: {
    entity: Object
  },
  data(){
    return {
      tabName: "prices",
    }
  },
  computed: {
    entities(){
      return this.entity.price;
    },
    csvHeaders(){
      return {
        'formated_value': {name: this.$gettext('Cena')},
        'currency_symbol': {name: this.$gettext('Symbol')},
        'currency_name': {name: this.$gettext('Název měny')},
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/vodVideos/detail/Prices.vue